/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 照会結果情報
 */
export interface EventReferInfo { 
    /**
     * イベントID：半角数字
     */
    eventId?: string;
    /**
     * イベント種別：半角
     */
    eventType?: string;
    /**
     * イベントステータス：半角数字
     */
    eventStatus?: string;
    /**
     * イベント詳細ステータス：半角数字
     */
    eventDetailStatus?: string;
    /**
     * 処理予定日時：日付
     */
    scheduleDateTime?: string;
    /**
     * イベント優先度：半角数字
     */
    eventPriority?: string;
    /**
     * イベント受付日時：日付
     */
    eventReceptionDateTime?: string;
    /**
     * イベント開始日時：日付
     */
    eventStartDateTime?: string;
    /**
     * イベント終了日時：日付
     */
    eventEndDateTime?: string;
    /**
     * イベント受付サーバ情報：半角
     */
    eventReceiptServerInfo?: string;
    /**
     * プロセス実行ID：半角数字
     */
    processExecuteId?: string;
    /**
     * 業務リクエストID：半角
     */
    businessRequestId?: string;
    /**
     * 登録者：半角
     */
    creator?: string;
    /**
     * 登録日時：日付
     */
    createTime?: string;
    /**
     * 最終更新者：半角
     */
    lastUpdater?: string;
    /**
     * 最終更新日時：日付
     */
    lastUpdateTime?: string;
}

